class SlideSection15 {
  constructor() {
      this.events();
  }
  events() {
    this.slidesection15Swiper()
    this.section360()
    let $this = this
  }

  section360(){
    // $(document).on('click', '.item-check-color360', function () {
    //   $(this).removeClass('active');
    //   $(this).addClass("active");
    // })
  }
  slidesection15Swiper(){
    
  
    var slideDesignSwiper = new Swiper(".section-design-list-swiper", {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: ".design-swiper-button-next",
        prevEl: ".design-swiper-button-prev",
      },
      breakpoints: {
        992: {
            slidesPerView: 3,
        },
      
        768: {
            slidesPerView: 2,
            spaceBetween: 30,
            
          },
        0:{
            slidesPerView: 1,
            spaceBetween: 10,
        }
       
      },
    });
    var slideAdvantagesSwiper = new Swiper(".section-advantages-image-swiper", {
      pagination: {
        el: ".swiper-pagination-section-advantages",
        clickable: true,
      },
      navigation: {
        nextEl: ".advantages-swiper-button-next",
        prevEl: ".advantages-swiper-button-prev",
      },
    });
    var swiperAdvantagesThumbs = new Swiper(".section-advantages-content-swiper", {
    });

    slideAdvantagesSwiper.controller.control = swiperAdvantagesThumbs;
    swiperAdvantagesThumbs.controller.control = slideAdvantagesSwiper;
    


  }
}
export default SlideSection15
